module.exports = __webpack_public_path__ + "static/media/nozomi-arimura-lose.d3b683c8.jpg";